import { BodyCell, HeaderColumn } from '@tableau/data-grid-1-wrapper';
import React from 'react';

import { cssClass } from '../../../style';
import { CommonStyles } from '../../styles/CommonStyles';

const CssPrefix = 'shared-widgets-datagrid';

/*
 * TODO: TFS 769624
 *
 * The following cell styles are copied from reactDataGrid.styl.
 *
 * When we upgrade VizPortal to Data Grid 2/3, the cellStyle/headerStyle/rowStyle props are gone,
 * so we will need to wrap every cell formatter in one of these wrappers to get consistent styles
 * on all the grids and also be able to apply the style overrides we need for some special cells.
 *
 * We are using these wrappers for some cells already to avoid passing the cellStyle props into the
 * data grid (which will make it easier to upgrade later), but since the cell/header styles are still
 * applied via CSS to the parent div, the styles that would cause conflict are commented out here.
 *
 * Once the data grid upgrade is complete and these wrappers are used on all the cell formatters,
 * uncomment the styles here and remove the relevant classes (tb-react-dg-hcell, tb-react-dg-bcell)
 * from reactDataGrid.styl.
 */

const DefaultBodyCellStyle = cssClass(CssPrefix, 'bcell-wrapper', {
  // paddingLeft: CommonStyles.Sizes.MediumSpace,
  // paddingRight: CommonStyles.Sizes.MediumSpace,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  verticalAlign: 'middle'
});

const DefaultHeaderCellStyle = cssClass(CssPrefix, 'hcell-wrapper', {
  // fontWeight: 'bold',
  // height: CommonStyles.Sizes.DataGridHeaderHeight,
  // lineHeight: CommonStyles.Sizes.DataGridHeaderHeight + 'px',
  // fontSize: CommonStyles.Sizes.LargeFontSize,
  // color: CommonStyles.Colors.Grey51
});

/**
 * This wrapper applies VizPortal's default styles to data grid body cells, allowing them to be
 * overridden if necessary. All cell formatters in VizPortal should be enclosed in this wrapper
 * to ensure consistent visual styling.
 */
export function StyledCellFormatter(OriginalCellFormatter: React.Factory<BodyCell.Props>,
                                    styleOverrides?: React.CSSProperties
): React.Factory<BodyCell.Props> {

  return function VizPortalDataGridBodyCell(props: BodyCell.Props) {
    return (
      <div className={ DefaultBodyCellStyle } style={ styleOverrides } >
        <OriginalCellFormatter {...props} />
      </div>
    );
  };
}


/**
 * This wrapper applies VizPortal's default styles to data grid header cells, allowing them to be
 * overridden if necessary. All cell formatters in VizPortal should be enclosed in this wrapper
 * to ensure consistent visual styling.
 */
export function StyledHeaderFormatter(OriginalHeaderFormatter: React.Factory<HeaderColumn.HeaderFormatterProps>,
                                      styleOverrides?: React.CSSProperties
): React.Factory<HeaderColumn.HeaderFormatterProps> {

  return function VizPortalDataGridHeaderCell(props: HeaderColumn.HeaderFormatterProps) {
    return (
      <div className={ DefaultHeaderCellStyle } style={ styleOverrides } >
        <OriginalHeaderFormatter {...props} />
      </div>
    );
  };
}


export function CenterAlignedHeader(headerFormatter: React.Factory<HeaderColumn.HeaderFormatterProps>) {
  return StyledHeaderFormatter(headerFormatter, CommonStyles.Layout.TextAlignCenter);
}

export function RightAlignedHeader(headerFormatter: React.Factory<HeaderColumn.HeaderFormatterProps>) {
  return StyledHeaderFormatter(headerFormatter, CommonStyles.Layout.TextAlignRight);
}

export function CenterAlignedCell(cellFormatter: React.Factory<BodyCell.Props>) {
  return StyledCellFormatter(cellFormatter, CommonStyles.Layout.TextAlignCenter);
}

export function RightAlignedCell(cellFormatter: React.Factory<BodyCell.Props>) {
  return StyledCellFormatter(cellFormatter, CommonStyles.Layout.TextAlignRight);
}
